import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { Plan_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
	planID: string;
};

export const usePlanArticleQuery = ({ hotelID, planID }: Props) => {
	const { data } = useCustomSuspenseQuery(Plan_DesignPage_Query, { variables: { hotelID, planID } });

	return {
		data,
	};
};
